import { useEffect } from "react";
import deferResizeObserverCallbacks from "helpers/deferResizeObserverCallbacks";

// The virtualised row measurement here is what triggers ResizeObserver's
// "loop completed with undelivered notifications" - see
// helpers/deferResizeObserverCallbacks for why that's benign. Scoped to this
// table's own mount lifecycle rather than patched globally at app boot, so
// every other ResizeObserver in the app keeps its native, undeferred timing.
const useScopedResizeObserverDefer = () => {
	useEffect(() => {
		const restore = deferResizeObserverCallbacks();
		return restore;
	}, []);
};

export default useScopedResizeObserverDefer;
